import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const postPettyCashRequest = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/request`,data);
        return response.data.data;
    } catch (error) {
        console.log("postPettyCash - error", error)
        return handleApiError(error)
    }
}


export const postPettyCashExpense = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/add-expense`,data);
        return response.data.data;
    } catch (error) {
        console.log("postPettyCashItems - error", error)
        return handleApiError(error)
    }
}

export const getUOMs = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/material-uom`);
        return response.data.data; 
    } catch (error) {
        console.log("getUOMs - error", error)
        return handleApiError(error)
    }
}

/*export const getPettyCash = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/get-petty-cash`,data);
        return response.data.data;
        
    } catch (error) {
        console.log("postPettyCash - error", error)
        return error
    }
}*/

export const getPettyCash = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/`,data);
        return response.data.data;
        
    } catch (error) {
        console.log("postPettyCash - error", error)
        return handleApiError(error)
    }
}

export const getPendingPettyCash = async (userId) => {

    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash/pending-petty-cash/${userId}`);
        return response.data.data;
        
    } catch (error) {
        console.log("postPettyCash - error", error)
        return error
    }
}

export const getSellerSearch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/expense/seller-search`,data);
        return response.data.data;
        
    } catch (error) {
        console.log("getSellerSearch - error", error)
        return handleApiError(error)
    }

}

export const getStatesList = async () => {

    try {
        const response = await axios.get(`${REACT_APP_API_URL}/state`);
        return response.data;
        
    } catch (error) {
        console.log("postPettyCash - error", error)
        return handleApiError(error)
    }
}

export const searchPettyCashes = async (data) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/search`, data);
        return response.data;
        
    } catch (error) {
        console.log("searchPettyCashes - error", error)
        return handleApiError(error)
    }
}

export const updatePettyCashBookingStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/updatePettyCashStatus`, data);
        return await response.data;
    } catch (error) {
        console.log("updatePettyCashBookingStatus - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashByPettyCashId = async (pettyCashId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash/get-petty-cash/${pettyCashId}`);
        return await response.data;
    } catch (error) {
        console.log("getPettyCashByPettyCashId - error", error)
        return handleApiError(error)
    }
}


export const getPettyCashVoucherDocument = async (pettyCashId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash/voucher/voucherDocument/${pettyCashId}`);
        return await response.data;
    } catch (error) {
        console.log("getPettyCashVoucherDocument - error", error)
        return handleApiError(error)
    }
}


export const cancelPettyCash = async (pettyCashId) => {

    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/cancel/${pettyCashId}`);
        return response.data.data;
        
    } catch (error) {
        console.log("cancelPettyCash - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashByVoucherNo = async (voucherNo) => {

    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash/get-pettycash-by-voucher-no/${voucherNo}`);
        return response.data.data;
        
    } catch (error) {
        console.log("getPettyCashByVoucherNo - error", error)
        return handleApiError(error)
    }
}

export const updatePettyCashSecondayPaymentStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash/update-seconday-payment-status`, data);
        return await response.data;
    } catch (error) {
        console.log("updatePettyCashSecondayPaymentStatus - error", error)
        return handleApiError(error)
    }
}